import _ from 'underscore';
import 'edge/endorsement/common/models/PolicyChange';
import Driver from 'edge/endorsement/pa/models/Driver';
import Vehicle from 'edge/endorsement/pa/models/Vehicle';

var nextId = void 0;

var PACoverables = function PACoverables(data) {
    if (data && _.isObject(data)) {
        this.drivers = _.map(data.drivers, function (d) {
            return new Driver(d);
        }, this);

        this.availableDrivers = _.map(data.availableDrivers, function (d) {
            return new Driver(d);
        }, this);

        this.vehicles = _.map(data.vehicles, function (v) {
            return new Vehicle(v);
        }, this);

        this.vehicleDrivers = _.map(data.vehicleDrivers, function (vehicleDriver) {
            return {
                vehicle: _.findWhere(this.vehicles, {
                    fixedId: vehicleDriver.vehicleID
                }),
                vehicleID: vehicleDriver.vehicleID,
                driver: _.findWhere(this.drivers, {
                    fixedId: vehicleDriver.driverID
                }),
                driverID: vehicleDriver.driverID
            };
        }, this);
    } else {
        this.drivers = [];
        this.vehicles = [];
        this.vehicleDrivers = [];
    }
};

PACoverables.prototype.createDriver = function () {
    var driver = new Driver();
    // extend
    driver.tempID = nextId();
    driver.isNew = true;
    this.drivers.push(driver);
    return driver;
};

PACoverables.prototype.createFromAvailableDriver = function (availableDriver) {
    var driver = new Driver(availableDriver);
    // extend
    driver.isNew = true;
    this.drivers.push(driver);
    return driver;
};

PACoverables.prototype.addDriver = function (driver) {
    this.drivers.push(driver);
};

PACoverables.prototype.removeDriver = function (driver) {
    var idx = _.indexOf(this.drivers, driver);
    if (idx >= 0) {
        _.each(this.vehicles, function (v) {
            this.removeDriverAssignment(driver, v);
        }, this);
        this.drivers.splice(idx, 1);
    }
};

PACoverables.prototype.createVehicle = function () {
    var v = new Vehicle({
        tempID: nextId()
    });
    v.isNew = true;
    this.vehicles.push(v);
    return v;
};

PACoverables.prototype.addVehicle = function (vehicle) {
    this.vehicles.push(vehicle);
};

PACoverables.prototype.removeVehicle = function (vehicle) {
    var idx = _.indexOf(this.vehicles, vehicle);
    if (idx >= 0) {
        _.each(this.drivers, function (d) {
            this.removeDriverAssignment(d, vehicle);
        }, this);
        this.vehicles.splice(idx, 1);
    }
};

PACoverables.prototype.isDriverAssigned = function (driver, vehicle) {
    return !!_.findWhere(this.vehicleDrivers, {
        driver: driver, vehicle: vehicle
    });
};

PACoverables.prototype.getAssignedDrivers = function (vehicle) {
    return _.pluck(_.where(this.vehicleDrivers, {
        vehicle: vehicle
    }), 'driver');
};

PACoverables.prototype.getAssignedVehicles = function (driver) {
    return _.pluck(_.where(this.vehicleDrivers, {
        driver: driver
    }), 'vehicle');
};

PACoverables.prototype.assignDriver = function (driver, vehicle) {
    var assignment = _.findWhere(this.vehicleDrivers, {
        driver: driver, vehicle: vehicle
    });
    if (!assignment) {
        this.vehicleDrivers.push({
            driver: driver, vehicle: vehicle
        });
    }
};

PACoverables.prototype.removeDriverAssignment = function (driver, vehicle) {
    var assignment = _.findWhere(this.vehicleDrivers, {
        driver: driver, vehicle: vehicle
    });
    if (assignment) {
        this.vehicleDrivers.splice(this.vehicleDrivers.indexOf(assignment), 1);
    }
};

function _buildHistory(policyChange, lob) {
    for (var i = 0; i < policyChange.history.length; i++) {
        var historyItem = policyChange.history[i];
        if (historyItem.entityType === 'driver') {
            historyItem.entity = _.findWhere(lob.coverables.drivers, {
                fixedId: historyItem.fixedId
            });
        } else if (historyItem.entityType === 'vehicle') {
            historyItem.entity = _.findWhere(lob.coverables.vehicles, {
                fixedId: historyItem.fixedId
            });
        }
    }
}

var PAPolicyChangeDataExtension = function PAPolicyChangeDataExtension(policyChange) {
    nextId = policyChange.nextId;

    var paData = policyChange.lobData.personalAuto || { coverables: {} };
    this.coverables = new PACoverables(paData.coverables);

    if (policyChange.history) {
        _buildHistory(policyChange, this);
    } else {
        policyChange.history = [];
    }

    this.offerings = paData.offerings;
};

PAPolicyChangeDataExtension.prototype.beforeSave = function () {
    this.coverables.availableDrivers = [];
    _.each(this.coverables.vehicleDrivers, function (assignment) {
        if (assignment.driver.fixedId) {
            assignment.driverID = assignment.driver.fixedId;
            delete assignment.driverTempID;
        } else {
            delete assignment.driverID;
            assignment.driverTempID = assignment.driver.tempID;
        }
        delete assignment.driver;
        if (assignment.vehicle.fixedId) {
            assignment.vehicleID = assignment.vehicle.fixedId;
            delete assignment.vehicleTempID;
        } else {
            delete assignment.vehicleID;
            assignment.vehicleTempID = assignment.vehicle.tempID;
        }
        delete assignment.vehicle;
    });
};

PAPolicyChangeDataExtension.prototype.validate = function () {
    this.coverables.unassignedDrivers = _.filter(this.coverables.drivers, function (d) {
        return !_.findWhere(this.coverables.vehicleDrivers, {
            driver: d
        });
    }, this);
    this.coverables.unassignedVehicles = _.filter(this.coverables.vehicles, function (v) {
        return !_.findWhere(this.coverables.vehicleDrivers, {
            vehicle: v
        });
    }, this);
    if (!this.coverables.unassignedDrivers || this.coverables.unassignedDrivers.length === 0) {
        this.coverables.unassignedDrivers = null;
    }
    if (!this.coverables.unassignedVehicles || this.coverables.unassignedVehicles.length === 0) {
        this.coverables.unassignedVehicles = null;
    }
    return !this.coverables.unassignedDrivers && !this.coverables.unassignedVehicles;
};

export default PAPolicyChangeDataExtension;


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=endorsement-products&equals=PersonalAuto!./common/js/src/edge/endorsement/pa/models/PAPolicyChangeDataExtension.js
// module id = 447
// module chunks = 0